import type { FunctionComponent, ReactElement } from 'react';
import { useCallback } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { headerActions } from '../../../store/slices/header/slice';
import { HeaderModal } from '../../../store/slices/header/types';
import { toastActions } from '../../../store/slices/toast/slice';
import { useIsLargerThanWide } from '../../../styles/hooks/media';
import { NavPages } from '../../nav/navPages/NavPagesConnected';
import { Toast } from '../../toast/Toast';
import type { ToastConnectedProps } from '../types';

export const GameCanceledToastConnected: FunctionComponent<ToastConnectedProps> = ({
  message,
  timeStamp,
  ...rest
}): ReactElement => {
  const dispatch = useCoreDispatch();
  const isWideScreen = useIsLargerThanWide();

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  const onBtnClick = (): void => {
    if (isWideScreen) {
      dispatch(headerActions.setOpenedModal(HeaderModal.Support));
    } else {
      dispatch(headerActions.setNavRoute([NavPages.HOME, NavPages.SUPPORT]));
    }

    closeFn();
  };

  const button = {
    tk: 'DETAILS',
    onClick: onBtnClick,
  };

  return <Toast button={button} message={message} onClose={closeFn} {...rest} />;
};
